/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this affiliated with Formula 1?`)
};

const es_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está afiliado esto a la Fórmula 1?`)
};

const de_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist das mit der Formel 1 verbunden?`)
};

const nl_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is dit gelieerd aan Formule 1?`)
};

const fr_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce site est-il affilié à la Formule 1 ?`)
};

const it_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse è affiliato alla Formula 1?`)
};

const pt_br2_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso é afiliado à Fórmula 1?`)
};

const pt_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto está afiliado à Formula 1?`)
};

const ja_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formula 1と提携していますか？`)
};

const zh_f1_faq5_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这与 Formula 1 有官方关联吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_faq5_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_faq5_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_faq5_q", locale)
	if (locale === "en") return en_f1_faq5_q(inputs)
	if (locale === "es") return es_f1_faq5_q(inputs)
	if (locale === "de") return de_f1_faq5_q(inputs)
	if (locale === "nl") return nl_f1_faq5_q(inputs)
	if (locale === "fr") return fr_f1_faq5_q(inputs)
	if (locale === "it") return it_f1_faq5_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_faq5_q(inputs)
	if (locale === "pt") return pt_f1_faq5_q(inputs)
	if (locale === "ja") return ja_f1_faq5_q(inputs)
	return zh_f1_faq5_q(inputs)
};